import * as actionTypes from './actionTypes';

export const addIngredient = (ingredientName) => {
  return {
    type: actionTypes.ADD_INGREDIENT,
    ingredientName: ingredientName
  }
};

export const removeIngredient = (ingredientName) => {
  return {
    type: actionTypes.REMOVE_INGREDIENT,
    ingredientName: ingredientName
  }
};

export const resetIngredients = () => {
  return {
    type: actionTypes.RESET_INGREDIENTS
  }
};
